import { usePmsSchedules } from 'app/components/pms-schedules/usePmsSchedules'
import { PmsSchedulesComponent } from 'app/components/pms-schedules/PmsSchedulesComponent'

export const handle = {
  title: `PMS Schedules`,
  breadcrumb: `PMS Schedules`,
}

export default function ProviderSchedules(): React.ReactElement {
  const { locations } = usePmsSchedules()

  return <PmsSchedulesComponent locations={locations} />
}
